import { EsquireClient } from "@/types/clients/esquire";

export default class GetReservationQrCodeRequest {
  public constructor(private readonly client: EsquireClient) {}

  public async send(): Promise<Blob | null> {
    const url = await this.client.fetchUrlFromSession("reservation-qr-code");

    const response = await this.client.fetch(
      () => new URL(url),
      {
        method: "GET"
      }
    );

    if (response.status === 404) {
      return null;
    }

    if (!response.ok) {
      await this.client.logOutIfForbidden(response.status);
      throw new Error("Failed to fetch reservation QR code");
    }

    return await response.blob();
  }
}
